// extracted by mini-css-extract-plugin
export default {"chart":"P_fW","fullscreen":"P_dt","close":"P_d8"};